require("core-js/modules/es.regexp.flags.js");
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.DatoCmsSearch = t() : e.DatoCmsSearch = t();
}(this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 11);
  }([function (e, t) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      !function (n) {
        function r() {}
        function o(e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }
        function i(e) {
          if (!(this instanceof i)) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof e) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], c(e, this);
        }
        function a(e, t) {
          for (; 3 === e._state;) e = e._value;
          if (0 === e._state) return void e._deferreds.push(t);
          e._handled = !0, i._immediateFn(function () {
            var n = 1 === e._state ? t.onFulfilled : t.onRejected;
            if (null === n) return void (1 === e._state ? l : u)(t.promise, e._value);
            var r;
            try {
              r = n(e._value);
            } catch (e) {
              return void u(t.promise, e);
            }
            l(t.promise, r);
          });
        }
        function l(e, t) {
          try {
            if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
            if (t && ("object" == typeof t || "function" == typeof t)) {
              var n = t.then;
              if (t instanceof i) return e._state = 3, e._value = t, void d(e);
              if ("function" == typeof n) return void c(o(n, t), e);
            }
            e._state = 1, e._value = t, d(e);
          } catch (t) {
            u(e, t);
          }
        }
        function u(e, t) {
          e._state = 2, e._value = t, d(e);
        }
        function d(e) {
          2 === e._state && 0 === e._deferreds.length && i._immediateFn(function () {
            e._handled || i._unhandledRejectionFn(e._value);
          });
          for (var t = 0, n = e._deferreds.length; t < n; t++) a(e, e._deferreds[t]);
          e._deferreds = null;
        }
        function s(e, t, n) {
          this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
        }
        function c(e, t) {
          var n = !1;
          try {
            e(function (e) {
              n || (n = !0, l(t, e));
            }, function (e) {
              n || (n = !0, u(t, e));
            });
          } catch (e) {
            if (n) return;
            n = !0, u(t, e);
          }
        }
        var f = setTimeout;
        i.prototype.catch = function (e) {
          return this.then(null, e);
        }, i.prototype.then = function (e, t) {
          var n = new this.constructor(r);
          return a(this, new s(e, t, n)), n;
        }, i.all = function (e) {
          return new i(function (t, n) {
            function r(e, a) {
              try {
                if (a && ("object" == typeof a || "function" == typeof a)) {
                  var l = a.then;
                  if ("function" == typeof l) return void l.call(a, function (t) {
                    r(e, t);
                  }, n);
                }
                o[e] = a, 0 == --i && t(o);
              } catch (e) {
                n(e);
              }
            }
            if (!e || void 0 === e.length) throw new TypeError("Promise.all accepts an array");
            var o = Array.prototype.slice.call(e);
            if (0 === o.length) return t([]);
            for (var i = o.length, a = 0; a < o.length; a++) r(a, o[a]);
          });
        }, i.resolve = function (e) {
          return e && "object" == typeof e && e.constructor === i ? e : new i(function (t) {
            t(e);
          });
        }, i.reject = function (e) {
          return new i(function (t, n) {
            n(e);
          });
        }, i.race = function (e) {
          return new i(function (t, n) {
            for (var r = 0, o = e.length; r < o; r++) e[r].then(t, n);
          });
        }, i._immediateFn = "function" == typeof t && function (e) {
          t(e);
        } || function (e) {
          f(e, 0);
        }, i._unhandledRejectionFn = function (e) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
        }, i._setImmediateFn = function (e) {
          i._immediateFn = e;
        }, i._setUnhandledRejectionFn = function (e) {
          i._unhandledRejectionFn = e;
        }, void 0 !== e && e.exports ? e.exports = i : n.Promise || (n.Promise = i);
      }(this);
    }).call(t, n(8).setImmediate);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    } /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
    var o = Object.getOwnPropertySymbols,
      i = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
        for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, l, u = r(e), d = 1; d < arguments.length; d++) {
        n = Object(arguments[d]);
        for (var s in n) i.call(n, s) && (u[s] = n[s]);
        if (o) {
          l = o(n);
          for (var c = 0; c < l.length; c++) a.call(n, l[c]) && (u[l[c]] = n[l[c]]);
        }
      }
      return u;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return t.replace(/\[h\](.+?)\[\/h\]/g, function (t, n) {
        var r = document.createElement("div");
        return r.innerHTML = e, r.children[0].innerText = n, r.children[0].outerHTML;
      });
    }
    function o(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "production";
      this.apiToken = e, this.environment = t;
    }
    var i = n(5),
      a = (n(2), "undefined" != typeof window ? window.Promise || n(1) : n(1));
    o.prototype = {
      search: function search(e, t) {
        t = Object.assign({
          highlightWith: '<strong class="highlight"></strong>',
          locale: null
        }, t);
        var n = "https://site-api.datocms.com/search-results?";
        n += "q=" + encodeURIComponent(e), n += "&environment=" + encodeURIComponent(this.environment), t.locale && (n += "&locale=" + encodeURIComponent(t.locale)), t.offset && (n += "&offset=" + encodeURIComponent(t.offset)), t.limit && (n += "&limit=" + encodeURIComponent(t.limit));
        var o = {
            url: n,
            headers: {
              Authorization: "API-Token " + this.apiToken,
              Accept: "application/json"
            }
          },
          l = r.bind(null, t.highlightWith);
        return new a(function (e, t) {
          i.ajax(o, function (n, r) {
            if (401 === n) return void t(new Error("[DatoCMS Site Search] Invalid API token: make sure the API token exists and has the proper permissions!"));
            var o = JSON.parse(r),
              i = o.data.map(function (e) {
                var t = e.attributes.highlight;
                return {
                  url: e.attributes.url,
                  title: t.title ? l(t.title[0]) : e.attributes.title,
                  body: t.body ? "..." + t.body.map(function (e) {
                    return l(e.trim());
                  }).join("...") + "..." : e.attributes.body_excerpt,
                  raw: {
                    title: e.attributes.title,
                    body: e.attributes.body_excerpt
                  }
                };
              });
            e({
              results: i,
              total: o.meta.total_count
            });
          });
        });
      }
    }, e.exports = o;
  }, function (e, t, n) {
    e.exports = n(14).default, e.exports.default = e.exports;
  }, function (e, t, n) {
    (function (e) {
      function n(t) {
        return t && e.XDomainRequest && !/MSIE 1/.test(navigator.userAgent) ? new XDomainRequest() : e.XMLHttpRequest ? new XMLHttpRequest() : void 0;
      }
      function r(e, t, n) {
        e[t] = e[t] || n;
      }
      var o = ["responseType", "withCredentials", "timeout", "onprogress"];
      t.ajax = function (t, i) {
        function a(e, t) {
          return function () {
            s || (i(void 0 === c.status ? e : c.status, 0 === c.status ? "Error" : c.response || c.responseText || t, c), s = !0);
          };
        }
        var l = t.headers || {},
          u = t.body,
          d = t.method || (u ? "POST" : "GET"),
          s = !1,
          c = n(t.cors);
        c.open(d, t.url, !0);
        var f = c.onload = a(200);
        c.onreadystatechange = function () {
          4 === c.readyState && f();
        }, c.onerror = a(null, "Error"), c.ontimeout = a(null, "Timeout"), c.onabort = a(null, "Abort"), u && (r(l, "X-Requested-With", "XMLHttpRequest"), e.FormData && u instanceof e.FormData || r(l, "Content-Type", "application/x-www-form-urlencoded"));
        for (var p, h = 0, v = o.length; h < v; h++) p = o[h], void 0 !== t[p] && (c[p] = t[p]);
        for (var p in l) c.setRequestHeader(p, l[p]);
        return c.send(u), c;
      };
    }).call(t, n(0));
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }
    function r() {
      throw new Error("clearTimeout has not been defined");
    }
    function o(e) {
      if (s === setTimeout) return setTimeout(e, 0);
      if ((s === n || !s) && setTimeout) return s = setTimeout, setTimeout(e, 0);
      try {
        return s(e, 0);
      } catch (t) {
        try {
          return s.call(null, e, 0);
        } catch (t) {
          return s.call(this, e, 0);
        }
      }
    }
    function i(e) {
      if (c === clearTimeout) return clearTimeout(e);
      if ((c === r || !c) && clearTimeout) return c = clearTimeout, clearTimeout(e);
      try {
        return c(e);
      } catch (t) {
        try {
          return c.call(null, e);
        } catch (t) {
          return c.call(this, e);
        }
      }
    }
    function a() {
      v && p && (v = !1, p.length ? h = p.concat(h) : m = -1, h.length && l());
    }
    function l() {
      if (!v) {
        var e = o(a);
        v = !0;
        for (var t = h.length; t;) {
          for (p = h, h = []; ++m < t;) p && p[m].run();
          m = -1, t = h.length;
        }
        p = null, v = !1, i(e);
      }
    }
    function u(e, t) {
      this.fun = e, this.array = t;
    }
    function d() {}
    var s,
      c,
      f = e.exports = {};
    !function () {
      try {
        s = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        s = n;
      }
      try {
        c = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        c = r;
      }
    }();
    var p,
      h = [],
      v = !1,
      m = -1;
    f.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      h.push(new u(e, t)), 1 !== h.length || v || o(l);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, f.title = "browser", f.browser = !0, f.env = {}, f.argv = [], f.version = "", f.versions = {}, f.on = d, f.addListener = d, f.once = d, f.off = d, f.removeListener = d, f.removeAllListeners = d, f.emit = d, f.prependListener = d, f.prependOnceListener = d, f.listeners = function (e) {
      return [];
    }, f.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, f.cwd = function () {
      return "/";
    }, f.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, f.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    (function (e, t) {
      !function (e, n) {
        "use strict";

        function r(e) {
          "function" != typeof e && (e = new Function("" + e));
          for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) t[n] = arguments[n + 1];
          var r = {
            callback: e,
            args: t
          };
          return d[u] = r, l(u), u++;
        }
        function o(e) {
          delete d[e];
        }
        function i(e) {
          var t = e.callback,
            r = e.args;
          switch (r.length) {
            case 0:
              t();
              break;
            case 1:
              t(r[0]);
              break;
            case 2:
              t(r[0], r[1]);
              break;
            case 3:
              t(r[0], r[1], r[2]);
              break;
            default:
              t.apply(n, r);
          }
        }
        function a(e) {
          if (s) setTimeout(a, 0, e);else {
            var t = d[e];
            if (t) {
              s = !0;
              try {
                i(t);
              } finally {
                o(e), s = !1;
              }
            }
          }
        }
        if (!e.setImmediate) {
          var l,
            u = 1,
            d = {},
            s = !1,
            c = e.document,
            f = Object.getPrototypeOf && Object.getPrototypeOf(e);
          f = f && f.setTimeout ? f : e, "[object process]" === {}.toString.call(e.process) ? function () {
            l = function l(e) {
              t.nextTick(function () {
                a(e);
              });
            };
          }() : function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                n = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = n, t;
            }
          }() ? function () {
            var t = "setImmediate$" + Math.random() + "$",
              n = function n(_n) {
                _n.source === e && "string" == typeof _n.data && 0 === _n.data.indexOf(t) && a(+_n.data.slice(t.length));
              };
            e.addEventListener ? e.addEventListener("message", n, !1) : e.attachEvent("onmessage", n), l = function l(n) {
              e.postMessage(t + n, "*");
            };
          }() : e.MessageChannel ? function () {
            var e = new MessageChannel();
            e.port1.onmessage = function (e) {
              a(e.data);
            }, l = function l(t) {
              e.port2.postMessage(t);
            };
          }() : c && "onreadystatechange" in c.createElement("script") ? function () {
            var e = c.documentElement;
            l = function l(t) {
              var n = c.createElement("script");
              n.onreadystatechange = function () {
                a(t), n.onreadystatechange = null, e.removeChild(n), n = null;
              }, e.appendChild(n);
            };
          }() : function () {
            l = function l(e) {
              setTimeout(a, 0, e);
            };
          }(), f.setImmediate = r, f.clearImmediate = o;
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(t, n(0), n(6));
  }, function (e, t, n) {
    (function (e) {
      function r(e, t) {
        this._id = e, this._clearFn = t;
      }
      var o = void 0 !== e && e || "undefined" != typeof self && self || window,
        i = Function.prototype.apply;
      t.setTimeout = function () {
        return new r(i.call(setTimeout, o, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new r(i.call(setInterval, o, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, r.prototype.unref = r.prototype.ref = function () {}, r.prototype.close = function () {
        this._clearFn.call(o, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, n(7), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(t, n(0));
  }, function (e, t, n) {
    e.exports = n(12).default, e.exports.default = e.exports;
  }, function (e, t, n) {
    e.exports = n(13).default, e.exports.default = e.exports;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    var l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(4),
      d = r(u),
      s = n(9),
      c = r(s),
      f = n(10),
      p = r(f),
      h = n(2),
      v = r(h),
      m = n(3),
      g = r(m),
      y = d.default.createVNode,
      _ = function (e) {
        function t(e) {
          o(this, t);
          var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.state = {
            isLoading: !1,
            query: e.initialQuery || "",
            total: null,
            results: null,
            locale: e.initialLocale || (e.locales ? e.locales[0].value : null),
            page: 0,
            isLocaleOpen: !1
          }, n.handleClickOutside = n.handleClickOutside.bind(n), n;
        }
        return a(t, e), l(t, [{
          key: "componentDidMount",
          value: function value() {
            document.addEventListener("click", this.handleClickOutside, !0), this.state.query && this.performSearch();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            document.removeEventListener("click", this.handleClickOutside, !0);
          }
        }, {
          key: "handleQueryChange",
          value: function value(e) {
            this.setState({
              query: e.target.value
            });
          }
        }, {
          key: "handleClickOutside",
          value: function value(e) {
            this.localeRef && !this.localeRef.contains(e.target) && this.setState({
              isLocaleOpen: !1
            });
          }
        }, {
          key: "handleLocaleChange",
          value: function value(e, t) {
            var n = this;
            t.preventDefault(), this.setState({
              locale: e,
              isLocaleOpen: !1
            }, function () {
              return n.performSearch();
            });
          }
        }, {
          key: "handleLocaleToggle",
          value: function value(e) {
            e.preventDefault(), this.setState({
              isLocaleOpen: !this.state.isLocaleOpen
            });
          }
        }, {
          key: "handlePageChange",
          value: function value(e, t) {
            var n = this;
            t.preventDefault(), this.setState({
              page: e
            }, function () {
              return n.performSearch();
            });
          }
        }, {
          key: "handleSubmit",
          value: function value(e) {
            e.preventDefault(), this.performSearch();
          }
        }, {
          key: "performSearch",
          value: function value() {
            var e = this;
            this.setState({
              isLoading: !0
            }), this.props.client.search(this.state.query, {
              offset: this.state.page * this.props.perPage,
              limit: this.props.perPage,
              locale: this.state.locale
            }).then(function (t) {
              var n = t.results,
                r = t.total;
              e.setState({
                results: n,
                total: r,
                isLoading: !1
              });
            });
          }
        }, {
          key: "render",
          value: function value() {
            return y(2, "form", "datocms-widget", [y(2, "div", "datocms-widget__header", y(2, "div", "datocms-widget__header__inner", [this.renderSearchInput(), this.props.locales && this.renderLocales()])), y(2, "div", "datocms-widget__body", [this.state.results && y(2, "div", "datocms-widget__results", this.state.results.map(this.renderResult.bind(this))), !this.state.isLoading && (!this.state.results || 0 === this.state.results.length) && y(2, "div", "datocms-widget__no-results", y(2, "div", "datocms-widget__no-results__label", "" === this.state.query ? "Please search something! :)" : 'No results found for "' + this.state.query + '" :(')), this.state.isLoading && this.renderLoading()]), y(2, "div", "datocms-widget__footer", [null !== this.state.total && this.renderPagination(), null !== this.state.total && this.renderTotal()])], {
              onSubmit: this.handleSubmit.bind(this)
            });
          }
        }, {
          key: "renderSearchInput",
          value: function value() {
            return y(2, "div", "datocms-widget__search", y(512, "input", "datocms-widget__search__input", null, {
              type: "text",
              placeholder: "What are you looking for?",
              onChange: this.handleQueryChange.bind(this),
              value: this.state.query
            }));
          }
        }, {
          key: "renderLocales",
          value: function value() {
            var e = this;
            return y(2, "div", "datocms-widget__locales", [y(2, "div", "datocms-widget__locales__active", [y(2, "span", "datocms-widget__locales__active__label", ["Find results in", " "]), y(2, "span", "datocms-widget__locales__active__value", this.props.locales.find(function (t) {
              return t.value === e.state.locale;
            }).label)], {
              onClick: this.handleLocaleToggle.bind(this)
            }), this.state.isLocaleOpen && y(2, "div", "datocms-widget__locales__menu", this.props.locales.map(function (t) {
              return y(2, "a", "datocms-widget__locales__menu__item", t.label, {
                href: "#",
                onClick: e.handleLocaleChange.bind(e, t.value)
              }, t.value);
            }))], null, null, function (t) {
              return e.localeRef = t;
            });
          }
        }, {
          key: "renderTotal",
          value: function value() {
            return y(2, "div", "datocms-widget__total", [y(2, "span", "datocms-widget__total__label", ["Total results found:", " "]), y(2, "span", "datocms-widget__total__value", this.state.total)]);
          }
        }, {
          key: "renderLoading",
          value: function value() {
            return y(2, "div", "datocms-widget__loading", [y(2, "div", "datocms-widget__loading__inner-1"), y(2, "div", "datocms-widget__loading__inner-2"), y(2, "div", "datocms-widget__loading__inner-3"), y(2, "div", "datocms-widget__loading__inner-4")]);
          }
        }, {
          key: "renderPagination",
          value: function value() {
            var e = this,
              t = Math.ceil(this.state.total / this.props.perPage),
              n = Array.apply(null, {
                length: t
              }).map(Number.call, Number);
            return y(2, "div", "datocms-widget__pagination", t > 1 && n.map(function (t) {
              var n = e.state.page === t,
                r = ["datocms-widget__pagination__page"];
              return n && r.push("is-active"), y(2, "a", r.join(" "), t + 1, {
                onClick: e.handlePageChange.bind(e, t),
                href: "#"
              }, t);
            }));
          }
        }, {
          key: "renderResult",
          value: function value(e) {
            return y(2, "div", "datocms-widget__result", [y(2, "a", "datocms-widget__result__title", null, {
              href: e.url,
              dangerouslySetInnerHTML: {
                __html: e.title || "No title"
              }
            }), y(2, "div", "datocms-widget__result__body", null, {
              dangerouslySetInnerHTML: {
                __html: e.body
              }
            }), y(2, "div", "datocms-widget__result__url", null, {
              dangerouslySetInnerHTML: {
                __html: e.url
              }
            })], null, e.url);
          }
        }]), t;
      }(c.default);
    g.default.prototype.addWidget = function (e, t) {
      d.default.render((0, p.default)(_, (0, v.default)({
        client: this,
        perPage: 8
      }, t)), document.querySelector(e));
    }, e.exports = g.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = typeof e;
      return "string" === t || "number" === t;
    }
    function o(e) {
      return d(e) || l(e);
    }
    function i(e) {
      return l(e) || !1 === e || u(e) || d(e);
    }
    function a(e) {
      return "function" == typeof e;
    }
    function l(e) {
      return null === e;
    }
    function u(e) {
      return !0 === e;
    }
    function d(e) {
      return void 0 === e;
    }
    function s(e) {
      throw e || (e = y), new Error("Inferno Error: " + e);
    }
    function c(e, t) {
      var n = {};
      if (e) for (var r in e) n[r] = e[r];
      if (t) for (var o in t) n[o] = t[o];
      return n;
    }
    function f() {
      this.listeners = [];
    }
    function p(e, t, n) {
      var r = b.get(e);
      void 0 === r && (r = [], b.set(e, r), w.then(function () {
        b.delete(e), e._updating = !0, v(e, t, function () {
          for (var t = 0, n = r.length; t < n; t++) r[t].call(e);
        }), e._updating = !1;
      })), o(n) || r.push(n);
    }
    function h(e, t, n) {
      a(t) && (t = t(e.state, e.props, e.context));
      var r = e._pendingState;
      if (o(r)) e._pendingState = t;else for (var i in t) r[i] = t[i];
      e._pendingSetState || e._blockRender ? (e._pendingSetState = !0, a(n) && e._blockRender && e._lifecycle.addListener(n.bind(e))) : e._updating ? p(e, !1, n) : (e._pendingSetState = !0, e._updating = !0, v(e, !1, n), e._updating = !1);
    }
    function v(e, t, n) {
      if (!e._unmounted) {
        if (t || !e._blockRender) {
          e._pendingSetState = !1;
          var u = e._pendingState,
            d = e.state,
            f = c(d, u),
            p = e.props,
            h = e.context;
          e._pendingState = null;
          var v,
            y = e._updateComponent(d, f, p, p, h, t, !0),
            b = !0;
          if (i(y)) v = m.createVNode(4096, null);else if (y === g) v = e._lastInput, b = !1;else if (r(y)) v = m.createVNode(1, null, null, y);else {
            if (_(y)) return s();
            v = y;
          }
          var w = e._lastInput,
            k = e._vNode,
            C = w.dom && w.dom.parentNode || (w.dom = k.dom);
          if (28 & v.flags && (v.parentVNode = k), e._lastInput = v, b) {
            var S;
            o(e.getChildContext) || (S = e.getChildContext()), S = o(S) ? e._childContext : c(h, S);
            var x = e._lifecycle;
            if (m.internal_patch(w, v, C, x, S, e._isSVG, !1), e._unmounted) return;
            x.trigger(), o(e.componentDidUpdate) || e.componentDidUpdate(p, d, h), l(m.options.afterUpdate) || m.options.afterUpdate(k);
          }
          var O = k.dom = v.dom;
          for (m.options.findDOMNodeEnabled && m.internal_DOMNodeMap.set(e, v.dom); !o(k = k.parentVNode);) (28 & k.flags) > 0 && (k.dom = O);
        } else e.state = e._pendingState, e._pendingState = null;
        a(n) && n.call(e);
      }
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var m = n(4),
      g = "$NO_OP",
      y = "a runtime error occured! Use Inferno in development environment to find the error.",
      _ = Array.isArray;
    f.prototype.addListener = function (e) {
      this.listeners.push(e);
    }, f.prototype.trigger = function () {
      for (var e, t = this.listeners; e = t.shift();) e();
    };
    var b = new Map(),
      w = Promise.resolve(),
      k = function k(e, t) {
        this.state = null, this._blockRender = !1, this._blockSetState = !0, this._pendingSetState = !1, this._pendingState = null, this._lastInput = null, this._vNode = null, this._unmounted = !1, this._lifecycle = null, this._childContext = null, this._isSVG = !1, this._updating = !0, this.props = e || m.EMPTY_OBJ, this.context = t || m.EMPTY_OBJ;
      };
    k.prototype.forceUpdate = function (e) {
      this._unmounted || v(this, !0, e);
    }, k.prototype.setState = function (e, t) {
      this._unmounted || (this._blockSetState ? s() : h(this, e, t));
    }, k.prototype._updateComponent = function (e, t, n, r, i, a, l) {
      if (!0 === this._unmounted && s(), n !== r || r === m.EMPTY_OBJ || e !== t || a) {
        if (n !== r || r === m.EMPTY_OBJ) {
          if (!o(this.componentWillReceiveProps) && !l) {
            if (this._blockRender = !0, this.componentWillReceiveProps(r, i), this._unmounted) return g;
            this._blockRender = !1;
          }
          this._pendingSetState && (t = c(t, this._pendingState), this._pendingSetState = !1, this._pendingState = null);
        }
        if (a || o(this.shouldComponentUpdate) || this.shouldComponentUpdate && this.shouldComponentUpdate(r, t, i)) {
          o(this.componentWillUpdate) || (this._blockSetState = !0, this.componentWillUpdate(r, t, i), this._blockSetState = !1), this.props = r, this.state = t, this.context = i, m.options.beforeRender && m.options.beforeRender(this);
          var u = this.render(r, t, i);
          return m.options.afterRender && m.options.afterRender(this), u;
        }
        this.props = r, this.state = t, this.context = i;
      }
      return g;
    }, k.prototype.render = function (e, t, n) {}, t.default = k;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return u(e) || a(e);
    }
    function o(e) {
      return a(e) || !1 === e || l(e) || u(e);
    }
    function i(e) {
      return "string" == typeof e;
    }
    function a(e) {
      return null === e;
    }
    function l(e) {
      return !0 === e;
    }
    function u(e) {
      return void 0 === e;
    }
    function d(e) {
      return "object" == typeof e;
    }
    function s() {
      this.listeners = [];
    }
    function c(e, t) {
      for (var n = [], a = arguments.length - 2; a-- > 0;) n[a] = arguments[a + 2];
      if (o(e) || d(e)) throw new Error("Inferno Error: createElement() name parameter cannot be undefined, null, false or true, It must be a string, class or function.");
      var l,
        s = n,
        c = null,
        h = null,
        v = null,
        m = 0;
      if (n && (1 === n.length ? s = n[0] : 0 === n.length && (s = void 0)), i(e)) {
        if (m = f.getFlagsForElementVnode(e), !r(t)) {
          l = {};
          for (var g in t) "className" === g || "class" === g ? v = t[g] : "key" === g ? h = t.key : "children" === g && u(s) ? s = t.children : "ref" === g ? c = t.ref : l[g] = t[g];
        }
      } else if (m = 16, u(s) || (t || (t = {}), t.children = s, s = null), !r(t)) {
        l = {};
        for (var y in t) p.has(y) ? (c || (c = {}), c[y] = t[y]) : "key" === y ? h = t.key : l[y] = t[y];
      }
      return f.createVNode(m, e, v, s, l, h, c);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var f = n(4);
    s.prototype.addListener = function (e) {
      this.listeners.push(e);
    }, s.prototype.trigger = function () {
      for (var e, t = this.listeners; e = t.shift();) e();
    };
    var p = new Set();
    p.add("onComponentWillMount"), p.add("onComponentDidMount"), p.add("onComponentWillUnmount"), p.add("onComponentShouldUpdate"), p.add("onComponentWillUpdate"), p.add("onComponentDidUpdate"), t.default = c;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return !f(e.prototype) && !f(e.prototype.render);
    }
    function o(e) {
      var t = typeof e;
      return "string" === t || "number" === t;
    }
    function i(e) {
      return f(e) || s(e);
    }
    function a(e) {
      return s(e) || !1 === e || c(e) || f(e);
    }
    function l(e) {
      return "function" == typeof e;
    }
    function u(e) {
      return "string" == typeof e;
    }
    function d(e) {
      return "number" == typeof e;
    }
    function s(e) {
      return null === e;
    }
    function c(e) {
      return !0 === e;
    }
    function f(e) {
      return void 0 === e;
    }
    function p(e) {
      return "object" == typeof e;
    }
    function h(e) {
      throw e || (e = st), new Error("Inferno Error: " + e);
    }
    function v(e, t) {
      var n = {};
      if (e) for (var r in e) n[r] = e[r];
      if (t) for (var o in t) n[o] = t[o];
      return n;
    }
    function m() {
      this.listeners = [];
    }
    function g(e, t, n, r) {
      var o = St.get(e);
      if (n) o || (o = {
        items: new Map(),
        docEvent: null
      }, o.docEvent = w(e, o), St.set(e, o)), t || Ct && "onClick" === e && C(r), o.items.set(r, n);else if (o) {
        var i = o.items;
        i.delete(r) && 0 === i.size && (document.removeEventListener(_(e), o.docEvent), St.delete(e));
      }
    }
    function y(e, t, n, r, o, i) {
      for (var a = t; r > 0;) {
        if (o && a.disabled) return;
        var l = n.get(a);
        if (l && (r--, i.dom = a, l.event ? l.event(l.data, e) : l(e), e.cancelBubble)) return;
        if (null === (a = a.parentNode)) return;
      }
    }
    function _(e) {
      return e.substr(2).toLowerCase();
    }
    function b() {
      this.cancelBubble = !0, this.stopImmediatePropagation();
    }
    function w(e, t) {
      var n = function n(e) {
        var n = t.items.size;
        if (n > 0) {
          e.stopPropagation = b;
          var r = {
            dom: document
          };
          try {
            Object.defineProperty(e, "currentTarget", {
              configurable: !0,
              get: function get() {
                return r.dom;
              }
            });
          } catch (e) {}
          y(e, e.target, t.items, n, "click" === e.type, r);
        }
      };
      return document.addEventListener(_(e), n), n;
    }
    function k() {}
    function C(e) {
      e.onclick = k;
    }
    function S(e) {
      return "checkbox" === e || "radio" === e;
    }
    function x(e) {
      var t = this.vNode,
        n = t.props || It,
        r = t.dom,
        o = n.value;
      if (n.onInput) {
        var i = n.onInput;
        i.event ? i.event(i.data, e) : i(e);
      } else n.oninput && n.oninput(e);
      var a = this.vNode,
        l = a.props || It;
      o !== l.value && M(l, r);
    }
    function O(e) {
      var t = this.vNode.props || It,
        n = t.onChange;
      n.event ? n.event(n.data, e) : n(e);
    }
    function N(e) {
      e.stopPropagation();
      var t = this.vNode,
        n = t.props || It,
        r = t.dom;
      if (n.onClick) {
        var o = n.onClick;
        o.event ? o.event(o.data, e) : o(e);
      } else n.onclick && n.onclick(e);
      M(this.vNode.props || It, r);
    }
    function T(e, t, n, r, o) {
      M(n, t), o && (t.vNode = e, r && (S(n.type) ? (t.onclick = N, t.onclick.wrapped = !0) : (t.oninput = x, t.oninput.wrapped = !0), n.onChange && (t.onchange = O, t.onchange.wrapped = !0)));
    }
    function M(e, t) {
      var n = e.type,
        r = e.value,
        o = e.checked,
        a = e.multiple,
        l = e.defaultValue,
        u = !i(r);
      n && n !== t.type && t.setAttribute("type", n), a && a !== t.multiple && (t.multiple = a), i(l) || u || (t.defaultValue = l + ""), S(n) ? (u && (t.value = r), i(o) || (t.checked = o)) : u && t.value !== r ? (t.defaultValue = r, t.value = r) : i(o) || (t.checked = o);
    }
    function I(e, t) {
      if ("optgroup" === e.type) {
        var n = e.children;
        if (ft(n)) for (var r = 0, o = n.length; r < o; r++) E(n[r], t);else Qe(n) && E(n, t);
      } else E(e, t);
    }
    function E(e, t) {
      var n = e.props || It,
        r = e.dom;
      r.value = n.value, ft(t) && -1 !== t.indexOf(n.value) || n.value === t ? r.selected = !0 : i(t) && i(n.selected) || (r.selected = n.selected || !1);
    }
    function P(e) {
      var t = this.vNode,
        n = t.props || It,
        r = t.dom,
        o = n.value;
      if (n.onChange) {
        var i = n.onChange;
        i.event ? i.event(i.data, e) : i(e);
      } else n.onchange && n.onchange(e);
      var a = this.vNode,
        l = a.props || It;
      o !== l.value && j(a, r, l, !1);
    }
    function L(e, t, n, r, o) {
      j(e, t, n, r), o && (t.vNode = e, r && (t.onchange = P, t.onchange.wrapped = !0));
    }
    function j(e, t, n, r) {
      n.multiple !== t.multiple && (t.multiple = n.multiple);
      var o = e.children;
      if (!a(o)) {
        var l = n.value;
        if (r && i(l) && (l = n.defaultValue), ft(o)) for (var u = 0, d = o.length; u < d; u++) I(o[u], l);else Qe(o) && I(o, l);
      }
    }
    function U(e) {
      var t = this.vNode.props || It,
        n = t.onChange;
      n.event ? n.event(n.data, e) : n(e);
    }
    function R(e) {
      var t = this.vNode,
        n = t.props || It,
        r = n.value;
      if (n.onInput) {
        var o = n.onInput;
        o.event ? o.event(o.data, e) : o(e);
      } else n.oninput && n.oninput(e);
      var i = this.vNode;
      r !== (i.props || It).value && V(i, t.dom, !1);
    }
    function D(e, t, n, r, o) {
      V(n, t, r), o && (t.vNode = e, r && (t.oninput = R, t.oninput.wrapped = !0, n.onChange && (t.onchange = U, t.onchange.wrapped = !0)));
    }
    function V(e, t, n) {
      var r = e.value,
        o = t.value;
      if (i(r)) {
        if (n) {
          var a = e.defaultValue;
          i(a) ? "" !== o && (t.defaultValue = "", t.value = "") : a !== o && (t.defaultValue = a, t.value = a);
        }
      } else o !== r && (t.defaultValue = r, t.value = r);
    }
    function A(e, t, n, r, o, i) {
      (512 & e) > 0 ? T(t, n, r, o, i) : (2048 & e) > 0 ? L(t, n, r, o, i) : (1024 & e) > 0 && D(t, n, r, o, i);
    }
    function F(e) {
      return e.type && S(e.type) ? !i(e.checked) : !i(e.value);
    }
    function W(e) {
      for (var t = e.firstChild; t;) if (8 === t.nodeType) {
        if ("!" === t.data) {
          var n = document.createTextNode("");
          e.replaceChild(n, t), t = t.nextSibling;
        } else {
          var r = t.previousSibling;
          e.removeChild(t), t = r || e.firstChild;
        }
      } else t = t.nextSibling;
    }
    function q(e, t, n, r, o, i) {
      var a = e.type,
        l = e.ref,
        u = e.props || It;
      if (i) {
        var d = t.namespaceURI === mt,
          s = Ie(e, a, u, r, d, n),
          c = s._lastInput;
        s._vNode = e, G(c, t, n, s._childContext, d), e.dom = c.dom, Ne(e, l, s, n), s._updating = !1, pt.findDOMNodeEnabled && Nt.set(s, t);
      } else {
        var f = Le(e, a, u, r);
        G(f, t, n, r, o), e.children = f, e.dom = f.dom, Te(u, l, t, n);
      }
      return t;
    }
    function H(e, t, n, r, o) {
      var l = e.children,
        u = e.props,
        d = e.className,
        s = e.flags,
        c = e.ref;
      if (o = o || (128 & s) > 0, 1 !== t.nodeType || t.tagName.toLowerCase() !== e.type) {
        var f = Se(e, null, n, r, o);
        return e.dom = f, Fe(t.parentNode, f, t), f;
      }
      if (e.dom = t, a(l) ? null === t.firstChild || ze(t, u) || (t.textContent = "") : B(l, t, n, r, o), u) {
        var p = !1,
          h = (3584 & s) > 0;
        h && (p = F(u));
        for (var v in u) ge(v, null, u[v], t, o, p);
        h && A(s, e, t, u, !0, p);
      }
      return i(d) ? "" !== t.className && t.removeAttribute("class") : o ? t.setAttribute("class", d) : t.className = d, c && Me(t, c, n), t;
    }
    function B(e, t, n, r, i) {
      W(t);
      var a = t.firstChild;
      if (o(e)) s(a) || 3 !== a.nodeType ? "" === e ? t.appendChild(document.createTextNode("")) : t.textContent = e : a.nodeValue !== e && (a.nodeValue = e), s(a) || (a = a.nextSibling);else if (ft(e)) for (var l = 0, u = e.length; l < u; l++) {
        var d = e[l];
        if (!s(d) && p(d)) if (s(a)) we(d, t, n, r, i);else {
          var c = a.nextSibling;
          G(d, a, n, r, i), a = c;
        }
      } else s(a) ? we(e, t, n, r, i) : (G(e, a, n, r, i), a = a.nextSibling);
      for (; a;) {
        var f = a.nextSibling;
        t.removeChild(a), a = f;
      }
    }
    function K(e, t) {
      if (3 !== t.nodeType) {
        var n = ke(e, null);
        return e.dom = n, Fe(t.parentNode, n, t), n;
      }
      var r = e.children;
      return t.nodeValue !== r && (t.nodeValue = r), e.dom = t, t;
    }
    function z(e, t) {
      return e.dom = t, t;
    }
    function G(e, t, n, r, o) {
      var i = e.flags;
      28 & i ? q(e, t, n, r, o, (4 & i) > 0) : 3970 & i ? H(e, t, n, r, o) : 1 & i ? K(e, t) : 4096 & i ? z(e, t) : h();
    }
    function J(e, t, n) {
      if (!s(t)) {
        var r = t.firstChild;
        if (!s(r)) {
          for (G(e, r, n, It, !1), r = t.firstChild; r = r.nextSibling;) t.removeChild(r);
          return !0;
        }
      }
      return !1;
    }
    function X(e, t, n, r) {
      var o = e.type,
        i = Ot.get(o);
      if (!f(i)) {
        var a = e.key,
          l = null === a ? i.nonKeyed : i.keyed.get(a);
        if (!f(l)) {
          var u = l.pop();
          if (!f(u)) return ue(u, e, null, t, n, r, !0), e.dom;
        }
      }
      return null;
    }
    function Y(e) {
      var t = e.type,
        n = e.key,
        r = Ot.get(t);
      if (f(r) && (r = {
        keyed: new Map(),
        nonKeyed: []
      }, Ot.set(t, r)), s(n)) r.nonKeyed.push(e);else {
        var o = r.keyed.get(n);
        f(o) && (o = [], r.keyed.set(n, o)), o.push(e);
      }
    }
    function $(e, t, n, r) {
      var o = e.type,
        i = xt.get(o);
      if (!f(i)) {
        var a = e.key,
          l = null === a ? i.nonKeyed : i.keyed.get(a);
        if (!f(l)) {
          var u = l.pop();
          if (!f(u)) {
            if (!se(u, e, null, t, n, r, (4 & e.flags) > 0, !0)) return e.dom;
          }
        }
      }
      return null;
    }
    function Q(e) {
      var t = e.ref;
      if (!t || !(t.onComponentWillMount || t.onComponentWillUnmount || t.onComponentDidMount || t.onComponentWillUpdate || t.onComponentDidUpdate)) {
        var n = e.type,
          r = e.key,
          o = xt.get(n);
        if (f(o) && (o = {
          keyed: new Map(),
          nonKeyed: []
        }, xt.set(n, o)), s(r)) o.nonKeyed.push(e);else {
          var i = o.keyed.get(r);
          f(i) && (i = [], o.keyed.set(r, i)), i.push(e);
        }
      }
    }
    function Z(e, t, n, r, o) {
      var u = e.flags,
        d = e.dom;
      if (28 & u) {
        var c = e.children,
          h = (4 & u) > 0,
          v = e.props || It,
          m = e.ref;
        o || (h ? c._unmounted || (s(pt.beforeUnmount) || pt.beforeUnmount(e), f(c.componentWillUnmount) || c.componentWillUnmount(), m && !o && m(null), c._unmounted = !0, pt.findDOMNodeEnabled && Nt.delete(c), Z(c._lastInput, null, c._lifecycle, !1, o)) : (i(m) || i(m.onComponentWillUnmount) || m.onComponentWillUnmount(d, v), Z(c, null, n, !1, o))), pt.recyclingEnabled && !h && (t || r) && Q(e);
      } else if (3970 & u) {
        var g = e.ref,
          y = e.props;
        !o && l(g) && g(null);
        var _ = e.children;
        if (!i(_)) if (ft(_)) for (var b = 0, w = _.length; b < w; b++) {
          var k = _[b];
          !a(k) && p(k) && Z(k, null, n, !1, o);
        } else p(_) && Z(_, null, n, !1, o);
        if (!s(y)) for (var C in y) null !== y[C] && me(C) && (ye(C, y[C], null, d), y[C] = null);
        pt.recyclingEnabled && (t || r) && Y(e);
      }
      s(t) || We(t, d);
    }
    function ee(e) {
      pt.findDOMNodeEnabled || h();
      var t = e && e.nodeType ? e : null;
      return Nt.get(e) || t;
    }
    function te(e) {
      for (var t = 0, n = Tt.length; t < n; t++) {
        var r = Tt[t];
        if (r.dom === e) return r;
      }
      return null;
    }
    function ne(e, t, n) {
      var r = {
        dom: e,
        input: t,
        lifecycle: n
      };
      return Tt.push(r), r;
    }
    function re(e) {
      for (var t = 0, n = Tt.length; t < n; t++) if (Tt[t] === e) return void Tt.splice(t, 1);
    }
    function oe(e, t) {
      if (Mt === t && h(), e !== dt) {
        var n = te(t);
        if (s(n)) {
          var r = new m();
          a(e) || (e.dom && (e = Je(e)), J(e, t, r) || we(e, t, r, It, !1), n = ne(t, e, r), r.trigger());
        } else {
          var o = n.lifecycle;
          o.listeners = [], i(e) ? (Z(n.input, t, o, !1, !1), re(n)) : (e.dom && (e = Je(e)), ae(n.input, e, t, o, It, !1, !1)), n.input = e, o.trigger();
        }
        if (n) {
          var l = n.input;
          if (l && 28 & l.flags) return l.children;
        }
      }
    }
    function ie(e) {
      return function (t, n) {
        e || (e = t), oe(n, e);
      };
    }
    function ae(e, t, n, r, o, i, a) {
      if (e !== t) {
        var l = e.flags,
          u = t.flags;
        if (28 & u) {
          var d = (4 & u) > 0;
          28 & l ? se(e, t, n, r, o, i, d, a) : Pe(n, Oe(t, null, r, o, i, d), e, r, a);
        } else 3970 & u ? 3970 & l ? ue(e, t, n, r, o, i, a) : Pe(n, Se(t, null, r, o, i), e, r, a) : 1 & u ? 1 & l ? ce(e, t) : Pe(n, ke(t, null), e, r, a) : 4096 & u ? 4096 & l ? fe(e, t) : Pe(n, Ce(t, null), e, r, a) : Ee(e, t, n, r, o, i, a);
      }
    }
    function le(e, t, n, r) {
      Qe(e) ? Z(e, t, n, !0, r) : ft(e) ? qe(t, e, n, r) : t.textContent = "";
    }
    function ue(e, t, n, r, o, a, l) {
      var u = t.type;
      if (e.type !== u) Ae(e, t, n, r, o, a, l);else {
        var d = e.dom,
          s = e.props,
          c = t.props,
          f = e.children,
          p = t.children,
          h = e.flags,
          v = t.flags,
          m = t.ref,
          g = e.className,
          y = t.className;
        if (t.dom = d, a = a || (128 & v) > 0, f !== p && de(h, v, f, p, d, r, o, !0 === a && "foreignObject" !== t.type, l), s !== c) {
          var _ = s || It,
            b = c || It,
            w = !1;
          if (b !== It) {
            var k = (3584 & v) > 0;
            k && (w = F(b));
            for (var C in b) {
              var S = b[C];
              ge(C, _[C], S, d, a, w);
            }
            k && A(v, t, d, b, l, w);
          }
          if (_ !== It) for (var x in _) i(b[x]) && !i(_[x]) && be(x, _[x], d, v);
        }
        g !== y && (i(y) ? d.removeAttribute("class") : a ? d.setAttribute("class", y) : d.className = y), m && (e.ref !== m || l) && Me(d, m, r);
      }
    }
    function de(e, t, n, r, i, l, u, d, s) {
      var c = !1,
        f = !1;
      if (64 & t ? c = !0 : (32 & e) > 0 && (32 & t) > 0 ? (f = !0, c = !0) : a(r) ? le(n, i, l, s) : a(n) ? o(r) ? je(i, r) : ft(r) ? xe(r, i, l, u, d) : we(r, i, l, u, d) : o(r) ? o(n) ? Ue(i, r) : (le(n, i, l, s), je(i, r)) : ft(r) ? ft(n) ? (c = !0, Be(n, r) && (f = !0)) : (le(n, i, l, s), xe(r, i, l, u, d)) : ft(n) ? (qe(i, n, l, s), we(r, i, l, u, d)) : Qe(r) && (Qe(n) ? ae(n, r, i, l, u, d, s) : (le(n, i, l, s), we(r, i, l, u, d))), c) {
        var p = n.length,
          h = r.length;
        0 === p ? h > 0 && xe(r, i, l, u, d) : 0 === h ? qe(i, n, l, s) : f ? he(n, r, i, l, u, d, s, p, h) : pe(n, r, i, l, u, d, s, p, h);
      }
    }
    function se(e, t, n, r, l, u, d, c) {
      var m = e.type,
        g = t.type,
        y = e.key,
        _ = t.key;
      if (m !== g || y !== _) return Ae(e, t, n, r, l, u, c), !1;
      var b = t.props || It;
      if (d) {
        var w = e.children;
        if (w._updating = !0, w._unmounted) {
          if (s(n)) return !0;
          Fe(n, Oe(t, null, r, l, u, (4 & t.flags) > 0), e.dom);
        } else {
          var k = !f(w.componentDidUpdate),
            C = w.state,
            S = k ? v(C, null) : C,
            x = w.props;
          t.children = w, w._isSVG = u;
          var O = w._lastInput,
            N = w._updateComponent(S, C, x, b, l, !1, !1);
          if (w._unmounted) return !1;
          var T,
            M = !0;
          i(w.getChildContext) || (T = w.getChildContext()), T = i(T) ? l : v(l, T), w._childContext = T, a(N) ? N = Ye() : N === dt ? (N = O, M = !1) : o(N) ? N = $e(N, null) : ft(N) ? h() : p(N) && (s(N.dom) || (N = Je(N))), 28 & N.flags ? N.parentVNode = t : 28 & O.flags && (O.parentVNode = t), w._lastInput = N, w._vNode = t, M && (ae(O, N, n, r, T, u, c), k && w.componentDidUpdate && w.componentDidUpdate(x, S), s(pt.afterUpdate) || pt.afterUpdate(t), pt.findDOMNodeEnabled && Nt.set(w, N.dom)), t.dom = N.dom;
        }
        w._updating = !1;
      } else {
        var I = !0,
          E = e.props,
          P = t.ref,
          L = !i(P),
          j = e.children,
          U = j;
        t.dom = e.dom, t.children = j, y !== _ ? I = !0 : L && !i(P.onComponentShouldUpdate) && (I = P.onComponentShouldUpdate(E, b)), !1 !== I && (L && !i(P.onComponentWillUpdate) && P.onComponentWillUpdate(E, b), U = g(b, l), a(U) ? U = Ye() : o(U) && U !== dt ? U = $e(U, null) : ft(U) ? h() : p(U) && (s(U.dom) || (U = Je(U))), U !== dt && (ae(j, U, n, r, l, u, c), t.children = U, L && !i(P.onComponentDidUpdate) && P.onComponentDidUpdate(E, b), t.dom = U.dom)), 28 & U.flags ? U.parentVNode = t : 28 & j.flags && (j.parentVNode = t);
      }
      return !1;
    }
    function ce(e, t) {
      var n = t.children,
        r = e.dom;
      t.dom = r, e.children !== n && (r.nodeValue = n);
    }
    function fe(e, t) {
      t.dom = e.dom;
    }
    function pe(e, t, n, r, o, i, a, l, u) {
      for (var d = l > u ? u : l, s = 0; s < d; s++) {
        var c = t[s];
        c.dom && (c = t[s] = Je(c)), ae(e[s], c, n, r, o, i, a);
      }
      if (l < u) for (s = d; s < u; s++) {
        var f = t[s];
        f.dom && (f = t[s] = Je(f)), Re(n, we(f, null, r, o, i));
      } else if (l > u) for (s = d; s < l; s++) Z(e[s], n, r, !1, a);
    }
    function he(e, t, n, r, o, i, a, l, u) {
      var d,
        c,
        p,
        h,
        v,
        m,
        g,
        y = l - 1,
        _ = u - 1,
        b = 0,
        w = 0,
        k = e[b],
        C = t[w],
        S = e[y],
        x = t[_];
      C.dom && (t[w] = C = Je(C)), x.dom && (t[_] = x = Je(x));
      e: {
        for (; k.key === C.key;) {
          if (ae(k, C, n, r, o, i, a), b++, w++, b > y || w > _) break e;
          k = e[b], C = t[w], C.dom && (t[w] = C = Je(C));
        }
        for (; S.key === x.key;) {
          if (ae(S, x, n, r, o, i, a), y--, _--, b > y || w > _) break e;
          S = e[y], x = t[_], x.dom && (t[_] = x = Je(x));
        }
      }
      if (b > y) {
        if (w <= _) for (m = _ + 1, v = m < u ? t[m].dom : null; w <= _;) g = t[w], g.dom && (t[w] = g = Je(g)), w++, De(n, we(g, null, r, o, i), v);
      } else if (w > _) for (; b <= y;) Z(e[b++], n, r, !1, a);else {
        var O = y - b + 1,
          N = _ - w + 1,
          T = new Array(N);
        for (d = 0; d < N; d++) T[d] = -1;
        var M = !1,
          I = 0,
          E = 0;
        if (N <= 4 || O * N <= 16) {
          for (d = b; d <= y; d++) if (p = e[d], E < N) for (c = w; c <= _; c++) if (h = t[c], p.key === h.key) {
            T[c - w] = d, I > c ? M = !0 : I = c, h.dom && (t[c] = h = Je(h)), ae(p, h, n, r, o, i, a), E++, e[d] = null;
            break;
          }
        } else {
          var P = new Map();
          for (d = w; d <= _; d++) P.set(t[d].key, d);
          for (d = b; d <= y; d++) p = e[d], E < N && (c = P.get(p.key), f(c) || (h = t[c], T[c - w] = d, I > c ? M = !0 : I = c, h.dom && (t[c] = h = Je(h)), ae(p, h, n, r, o, i, a), E++, e[d] = null));
        }
        if (O === l && 0 === E) for (qe(n, e, r, a); w < N;) g = t[w], g.dom && (t[w] = g = Je(g)), w++, De(n, we(g, null, r, o, i), null);else {
          for (d = O - E; d > 0;) p = e[b++], s(p) || (Z(p, n, r, !0, a), d--);
          if (M) {
            var L = ve(T);
            for (c = L.length - 1, d = N - 1; d >= 0; d--) -1 === T[d] ? (I = d + w, g = t[I], g.dom && (t[I] = g = Je(g)), m = I + 1, De(n, we(g, null, r, o, i), m < u ? t[m].dom : null)) : c < 0 || d !== L[c] ? (I = d + w, g = t[I], m = I + 1, De(n, g.dom, m < u ? t[m].dom : null)) : c--;
          } else if (E !== N) for (d = N - 1; d >= 0; d--) -1 === T[d] && (I = d + w, g = t[I], g.dom && (t[I] = g = Je(g)), m = I + 1, De(n, we(g, null, r, o, i), m < u ? t[m].dom : null));
        }
      }
    }
    function ve(e) {
      var t,
        n,
        r,
        o,
        i,
        a = e.slice(0),
        l = [0],
        u = e.length;
      for (t = 0; t < u; t++) {
        var d = e[t];
        if (-1 !== d) {
          if (n = l[l.length - 1], e[n] < d) {
            a[t] = n, l.push(t);
            continue;
          }
          for (r = 0, o = l.length - 1; r < o;) i = (r + o) / 2 | 0, e[l[i]] < d ? r = i + 1 : o = i;
          d < e[l[r]] && (r > 0 && (a[t] = l[r - 1]), l[r] = t);
        }
      }
      for (r = l.length, o = l[r - 1]; r-- > 0;) l[r] = o, o = a[o];
      return l;
    }
    function me(e) {
      return "o" === e[0] && "n" === e[1];
    }
    function ge(e, t, n, r, o, a) {
      if (t !== n) {
        if (wt.has(e) || a && "value" === e) return;
        if (yt.has(e)) e = "autoFocus" === e ? e.toLowerCase() : e, r[e] = !!n;else if (gt.has(e)) {
          var l = i(n) ? "" : n;
          r[e] !== l && (r[e] = l);
        } else if (me(e)) ye(e, t, n, r);else if (i(n)) r.removeAttribute(e);else if ("style" === e) _e(t, n, r);else if ("dangerouslySetInnerHTML" === e) {
          var u = t && t.__html,
            d = n && n.__html;
          u !== d && (i(d) || Ke(r, d) || (r.innerHTML = d));
        } else o && _t.has(e) ? r.setAttributeNS(_t.get(e), e, n) : r.setAttribute(e, n);
      }
    }
    function ye(e, t, n, r) {
      if (t !== n) if (kt.has(e)) g(e, t, n, r);else {
        var o = e.toLowerCase(),
          a = r[o];
        if (a && a.wrapped) return;
        if (l(n) || i(n)) r[o] = n;else {
          var u = n.event;
          u && l(u) ? r[o] = function (e) {
            u(n.data, e);
          } : h();
        }
      }
    }
    function _e(e, t, n) {
      var r,
        o,
        a = n.style;
      if (u(t)) return void (a.cssText = t);
      if (i(e) || u(e)) for (r in t) o = t[r], a[r] = !d(o) || bt.has(r) ? o : o + "px";else {
        for (r in t) (o = t[r]) !== e[r] && (a[r] = !d(o) || bt.has(r) ? o : o + "px");
        for (r in e) i(t[r]) && (a[r] = "");
      }
    }
    function be(e, t, n, r) {
      "value" === e ? n.value = 2048 & r ? null : "" : "style" === e ? n.removeAttribute("style") : me(e) ? g(e, t, null, n) : n.removeAttribute(e);
    }
    function we(e, t, n, r, o) {
      var i = e.flags;
      return 3970 & i ? Se(e, t, n, r, o) : 28 & i ? Oe(e, t, n, r, o, (4 & i) > 0) : 4096 & i ? Ce(e, t) : 1 & i ? ke(e, t) : void h();
    }
    function ke(e, t) {
      var n = document.createTextNode(e.children);
      return e.dom = n, s(t) || Re(t, n), n;
    }
    function Ce(e, t) {
      var n = document.createTextNode("");
      return e.dom = n, s(t) || Re(t, n), n;
    }
    function Se(e, t, n, r, i) {
      var l;
      if (pt.recyclingEnabled && (l = X(e, n, r, i), !s(l))) return s(t) || Re(t, l), l;
      var u = e.flags;
      i = i || (128 & u) > 0, l = Ve(e.type, i);
      var d = e.children,
        c = e.props,
        f = e.className,
        p = e.ref;
      if (e.dom = l, !a(d)) if (o(d)) je(l, d);else {
        var h = !0 === i && "foreignObject" !== e.type;
        ft(d) ? xe(d, l, n, r, h) : Qe(d) && we(d, l, n, r, h);
      }
      if (!s(c)) {
        var v = !1,
          m = (3584 & u) > 0;
        m && (v = F(c));
        for (var g in c) ge(g, null, c[g], l, i, v);
        m && A(u, e, l, c, !0, v);
      }
      return null !== f && (i ? l.setAttribute("class", f) : l.className = f), s(p) || Me(l, p, n), s(t) || Re(t, l), l;
    }
    function xe(e, t, n, r, o) {
      for (var i = 0, l = e.length; i < l; i++) {
        var u = e[i];
        a(u) || (u.dom && (e[i] = u = Je(u)), we(e[i], t, n, r, o));
      }
    }
    function Oe(e, t, n, r, o, i) {
      var a;
      if (pt.recyclingEnabled && (a = $(e, n, r, o), !s(a))) return s(t) || Re(t, a), a;
      var l = e.type,
        u = e.props || It,
        d = e.ref;
      if (i) {
        var c = Ie(e, l, u, r, o, n),
          f = c._lastInput;
        c._vNode = e, e.dom = a = we(f, null, n, c._childContext, o), s(t) || Re(t, a), Ne(e, d, c, n), c._updating = !1, pt.findDOMNodeEnabled && Nt.set(c, a);
      } else {
        var p = Le(e, l, u, r);
        e.dom = a = we(p, null, n, r, o), e.children = p, Te(u, d, a, n), s(t) || Re(t, a);
      }
      return a;
    }
    function Ne(e, t, n, r) {
      t && (l(t) ? t(n) : h());
      var o = !f(n.componentDidMount),
        i = pt.afterMount;
      !o && s(i) || r.addListener(function () {
        n._updating = !0, i && i(e), o && n.componentDidMount(), n._updating = !1;
      });
    }
    function Te(e, t, n, r) {
      t && (i(t.onComponentWillMount) || t.onComponentWillMount(e), i(t.onComponentDidMount) || r.addListener(function () {
        return t.onComponentDidMount(n, e);
      }));
    }
    function Me(e, t, n) {
      if (l(t)) n.addListener(function () {
        return t(e);
      });else {
        if (a(t)) return;
        h();
      }
    }
    function Ie(e, t, n, r, l, u) {
      f(r) && (r = It);
      var d = new t(n, r);
      if (e.children = d, d._blockSetState = !1, d.context = r, d.props === It && (d.props = n), d._lifecycle = u, d._unmounted = !1, d._isSVG = l, !i(d.componentWillMount)) {
        if (d._blockRender = !0, d.componentWillMount(), d._pendingSetState) {
          var c = d.state,
            p = d._pendingState;
          if (null === c) d.state = p;else for (var m in p) c[m] = p[m];
          d._pendingSetState = !1, d._pendingState = null;
        }
        d._blockRender = !1;
      }
      var g;
      i(d.getChildContext) || (g = d.getChildContext()), i(g) ? d._childContext = r : d._childContext = v(r, g), s(pt.beforeRender) || pt.beforeRender(d);
      var y = d.render(n, d.state, r);
      return s(pt.afterRender) || pt.afterRender(d), ft(y) ? h() : a(y) ? y = Ye() : o(y) ? y = $e(y, null) : (y.dom && (y = Je(y)), 28 & y.flags && (y.parentVNode = e)), d._lastInput = y, d;
    }
    function Ee(e, t, n, r, o, i, a) {
      Pe(n, we(t, null, r, o, i), e, r, a);
    }
    function Pe(e, t, n, r, o) {
      Z(n, null, r, !1, o), Fe(e, t, n.dom);
    }
    function Le(e, t, n, r) {
      var i = t(n, r);
      return ft(i) ? h() : a(i) ? i = Ye() : o(i) ? i = $e(i, null) : (i.dom && (i = Je(i)), 28 & i.flags && (i.parentVNode = e)), i;
    }
    function je(e, t) {
      "" !== t ? e.textContent = t : e.appendChild(document.createTextNode(""));
    }
    function Ue(e, t) {
      var n = e.firstChild;
      s(n) ? je(e, t) : n.nodeValue = t;
    }
    function Re(e, t) {
      e.appendChild(t);
    }
    function De(e, t, n) {
      i(n) ? Re(e, t) : e.insertBefore(t, n);
    }
    function Ve(e, t) {
      return !0 === t ? document.createElementNS(mt, e) : document.createElement(e);
    }
    function Ae(e, t, n, r, o, i, a) {
      Z(e, null, r, !1, a);
      var l = we(t, null, r, o, i);
      t.dom = l, Fe(n, l, e.dom);
    }
    function Fe(e, t, n) {
      e || (e = n.parentNode), e.replaceChild(t, n);
    }
    function We(e, t) {
      e.removeChild(t);
    }
    function qe(e, t, n, r) {
      (!pt.recyclingEnabled || pt.recyclingEnabled && !r) && He(null, t, n, r), e.textContent = "";
    }
    function He(e, t, n, r) {
      for (var o = 0, i = t.length; o < i; o++) {
        var l = t[o];
        a(l) || Z(l, e, n, !0, r);
      }
    }
    function Be(e, t) {
      return t.length > 0 && !i(t[0]) && !i(t[0].key) && e.length > 0 && !i(e[0]) && !i(e[0].key);
    }
    function Ke(e, t) {
      var n = document.createElement("i");
      return n.innerHTML = t, n.innerHTML === e.innerHTML;
    }
    function ze(e, t) {
      return Boolean(t && t.dangerouslySetInnerHTML && t.dangerouslySetInnerHTML.__html && Ke(e, t.dangerouslySetInnerHTML.__html));
    }
    function Ge(e, t, n, o, i, a, l, u) {
      16 & e && (e = r(t) ? 4 : 8);
      var d = {
        children: void 0 === o ? null : o,
        className: void 0 === n ? null : n,
        dom: null,
        flags: e,
        key: void 0 === a ? null : a,
        props: void 0 === i ? null : i,
        ref: void 0 === l ? null : l,
        type: t
      };
      return !0 !== u && lt(d), null !== pt.createVNode && pt.createVNode(d), d;
    }
    function Je(e) {
      var t,
        n = e.flags;
      if (28 & n) {
        var r,
          i = e.props;
        if (s(i)) r = It;else {
          r = {};
          for (var l in i) r[l] = i[l];
        }
        t = Ge(n, e.type, null, null, r, e.key, e.ref, !0);
        var u = t.props,
          d = u.children;
        if (d) if (ft(d)) {
          var c = d.length;
          if (c > 0) {
            for (var f = [], p = 0; p < c; p++) {
              var h = d[p];
              o(h) ? f.push(h) : !a(h) && Qe(h) && f.push(Je(h));
            }
            u.children = f;
          }
        } else Qe(d) && (u.children = Je(d));
        t.children = null;
      } else if (3970 & n) {
        var v,
          m = e.children,
          g = e.props;
        if (null === g) v = It;else {
          v = {};
          for (var y in g) v[y] = g[y];
        }
        t = Ge(n, e.type, e.className, m, v, e.key, e.ref, !m);
      } else 1 & n && (t = $e(e.children, e.key));
      return t;
    }
    function Xe(e, t) {
      for (var n = [], r = arguments.length - 2; r-- > 0;) n[r] = arguments[r + 2];
      var i = n,
        l = n.length;
      l > 0 && !f(n[0]) && (t || (t = {}), 1 === l && (i = n[0]), f(i) || (t.children = i));
      var u;
      if (ft(e)) {
        for (var d = [], s = 0, c = e.length; s < c; s++) d.push(Je(e[s]));
        u = d;
      } else {
        var p = e.flags,
          h = e.className,
          m = e.key,
          g = e.ref;
        if (t && (t.hasOwnProperty("className") && (h = t.className), t.hasOwnProperty("ref") && (g = t.ref), t.hasOwnProperty("key") && (m = t.key)), 28 & p) {
          u = Ge(p, e.type, h, null, e.props || t ? v(e.props, t) : It, m, g, !0);
          var y = u.props;
          if (y) {
            var _ = y.children;
            if (_) if (ft(_)) {
              var b = _.length;
              if (b > 0) {
                for (var w = [], k = 0; k < b; k++) {
                  var C = _[k];
                  o(C) ? w.push(C) : !a(C) && Qe(C) && w.push(Je(C));
                }
                y.children = w;
              }
            } else Qe(_) && (y.children = Je(_));
          }
          u.children = null;
        } else 3970 & p ? (i = t && !f(t.children) ? t.children : e.children, u = Ge(p, e.type, h, i, e.props || t ? v(e.props, t) : It, m, g, !1)) : 1 & p && (u = $e(e.children, m));
      }
      return u;
    }
    function Ye() {
      return Ge(4096, null);
    }
    function $e(e, t) {
      return Ge(1, null, null, e, null, t);
    }
    function Qe(e) {
      return !!e.flags;
    }
    function Ze(e, t) {
      return t.key = e, t;
    }
    function et(e, t) {
      return d(e) && (e = "." + e), s(t.key) || "." === t.key[0] ? Ze(e, t) : t;
    }
    function tt(e, t) {
      return t.key = e + t.key, t;
    }
    function nt(e, t, n, r) {
      for (var i = e.length; n < i; n++) {
        var l = e[n],
          u = r + "." + n;
        a(l) || (ft(l) ? nt(l, t, 0, u) : (o(l) ? l = $e(l, null) : (Qe(l) && l.dom || l.key && "." === l.key[0]) && (l = Je(l)), l = s(l.key) || "." === l.key[0] ? Ze(u, l) : tt(r, l), t.push(l)));
      }
    }
    function rt(e) {
      var t;
      !0 === e.$ ? e = e.slice() : e.$ = !0;
      for (var n = 0, r = e.length; n < r; n++) {
        var i = e[n];
        if (a(i) || ft(i)) {
          var l = (t || e).slice(0, n);
          return nt(e, l, n, ""), l;
        }
        o(i) ? (t || (t = e.slice(0, n)), t.push(et(n, $e(i, null)))) : Qe(i) && null !== i.dom || s(i.key) && 0 == (64 & i.flags) ? (t || (t = e.slice(0, n)), t.push(et(n, Je(i)))) : t && t.push(et(n, Je(i)));
      }
      return t || e;
    }
    function ot(e) {
      return ft(e) ? rt(e) : Qe(e) && null !== e.dom ? Je(e) : e;
    }
    function it(e, t, n) {
      3970 & e.flags && (i(n) && t.hasOwnProperty("children") && (e.children = t.children), t.hasOwnProperty("className") && (e.className = t.className || null, delete t.className)), t.hasOwnProperty("ref") && (e.ref = t.ref, delete t.ref), t.hasOwnProperty("key") && (e.key = t.key, delete t.key);
    }
    function at(e) {
      return "svg" === e ? 128 : "input" === e ? 512 : "select" === e ? 2048 : "textarea" === e ? 1024 : "media" === e ? 256 : 2;
    }
    function lt(e) {
      var t = e.props,
        n = e.children;
      if (28 & e.flags) {
        var r = e.type,
          o = r.defaultProps;
        if (!i(o)) if (t) for (var l in o) f(t[l]) && (t[l] = o[l]);else t = e.props = o;
        u(r) && (e.flags = at(r), t && t.children && (e.children = t.children, n = t.children));
      }
      t && (it(e, t, n), a(t.children) || (t.children = ot(t.children))), a(n) || (e.children = ot(n));
    }
    function ut(e, t) {
      return l(t) ? {
        data: e,
        event: t
      } : null;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var dt = "$NO_OP",
      st = "a runtime error occured! Use Inferno in development environment to find the error.",
      ct = !("undefined" == typeof window || !window.document),
      ft = Array.isArray;
    m.prototype.addListener = function (e) {
      this.listeners.push(e);
    }, m.prototype.trigger = function () {
      for (var e, t = this.listeners; e = t.shift();) e();
    };
    var pt = {
        afterMount: null,
        afterRender: null,
        afterUpdate: null,
        beforeRender: null,
        beforeUnmount: null,
        createVNode: null,
        findDOMNodeEnabled: !1,
        recyclingEnabled: !1,
        roots: []
      },
      ht = "http://www.w3.org/1999/xlink",
      vt = "http://www.w3.org/XML/1998/namespace",
      mt = "http://www.w3.org/2000/svg",
      gt = new Set();
    gt.add("volume"), gt.add("defaultChecked");
    var yt = new Set();
    yt.add("muted"), yt.add("scoped"), yt.add("loop"), yt.add("open"), yt.add("checked"), yt.add("default"), yt.add("capture"), yt.add("disabled"), yt.add("readOnly"), yt.add("required"), yt.add("autoplay"), yt.add("controls"), yt.add("seamless"), yt.add("reversed"), yt.add("allowfullscreen"), yt.add("novalidate"), yt.add("hidden"), yt.add("autoFocus"), yt.add("selected"), yt.add("indeterminate");
    var _t = new Map();
    _t.set("xlink:href", ht), _t.set("xlink:arcrole", ht), _t.set("xlink:actuate", ht), _t.set("xlink:show", ht), _t.set("xlink:role", ht), _t.set("xlink:title", ht), _t.set("xlink:type", ht), _t.set("xml:base", vt), _t.set("xml:lang", vt), _t.set("xml:space", vt);
    var bt = new Set();
    bt.add("animationIterationCount"), bt.add("borderImageOutset"), bt.add("borderImageSlice"), bt.add("borderImageWidth"), bt.add("boxFlex"), bt.add("boxFlexGroup"), bt.add("boxOrdinalGroup"), bt.add("columnCount"), bt.add("flex"), bt.add("flexGrow"), bt.add("flexPositive"), bt.add("flexShrink"), bt.add("flexNegative"), bt.add("flexOrder"), bt.add("gridRow"), bt.add("gridColumn"), bt.add("fontWeight"), bt.add("lineClamp"), bt.add("lineHeight"), bt.add("opacity"), bt.add("order"), bt.add("orphans"), bt.add("tabSize"), bt.add("widows"), bt.add("zIndex"), bt.add("zoom"), bt.add("fillOpacity"), bt.add("floodOpacity"), bt.add("stopOpacity"), bt.add("strokeDasharray"), bt.add("strokeDashoffset"), bt.add("strokeMiterlimit"), bt.add("strokeOpacity"), bt.add("strokeWidth");
    var wt = new Set();
    wt.add("children"), wt.add("childrenType"), wt.add("defaultValue"), wt.add("ref"), wt.add("key"), wt.add("checked"), wt.add("multiple");
    var kt = new Set();
    kt.add("onClick"), kt.add("onMouseDown"), kt.add("onMouseUp"), kt.add("onMouseMove"), kt.add("onSubmit"), kt.add("onDblClick"), kt.add("onKeyDown"), kt.add("onKeyUp"), kt.add("onKeyPress");
    var Ct = ct && !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform),
      St = new Map(),
      xt = new Map(),
      Ot = new Map(),
      Nt = new Map(),
      Tt = pt.roots,
      Mt = ct ? document.body : null,
      It = {},
      Et = {
        EMPTY_OBJ: It,
        NO_OP: dt,
        cloneVNode: Xe,
        createRenderer: ie,
        createVNode: Ge,
        findDOMNode: ee,
        getFlagsForElementVnode: at,
        internal_DOMNodeMap: Nt,
        internal_isUnitlessNumber: bt,
        internal_normalize: lt,
        internal_patch: ae,
        linkEvent: ut,
        options: pt,
        render: oe,
        version: "3.10.1"
      };
    t.default = Et, t.EMPTY_OBJ = It, t.NO_OP = dt, t.cloneVNode = Xe, t.createRenderer = ie, t.createVNode = Ge, t.findDOMNode = ee, t.getFlagsForElementVnode = at, t.internal_DOMNodeMap = Nt, t.internal_isUnitlessNumber = bt, t.internal_normalize = lt, t.internal_patch = ae, t.linkEvent = ut, t.options = pt, t.render = oe, t.version = "3.10.1";
  }]);
});